import React, { useEffect, useState } from 'react';
import { getDisplayImageUrl } from '../../utils/imageUtils';
import SEO from '../shared/SEO';
import { ConfigContext } from '../../providers/ConfigContext';
import '../../styles/Contact.css';

const Contact = () => {
  const { config } = React.useContext(ConfigContext);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/store-locations`);
        if (res.ok) {
          const data = await res.json();
          setLocations(data);
          if (data.length > 0) setSelected(data[0]);
        }
      } catch (err) {
        console.error('Error loading store locations:', err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Google My Maps embed (gratis, soporta múltiples pins y estilos básicos)
  // 1. Creá tu mapa en https://www.google.com/mymaps
  // 2. Agregá tus locales como pins
  // 3. Compartir → "Incorporar en mi sitio" → copiá el src del iframe
  // 4. Pegalo en REACT_APP_MY_MAPS_URL o reemplazá la URL de abajo
  const MY_MAPS_EMBED_URL = process.env.REACT_APP_MY_MAPS_URL || '';
  // Ejemplo: 'https://www.google.com/maps/d/embed?mid=1ABC123xyz&ehbc=2E312F'

  return (
    <>
      <SEO
        title="Contacto"
        description="Encontrá nuestros locales y visitanos"
      />

      <div className="contact-page">
        <div className="contact-hero">
          <h1 className="contact-title">Nuestros Locales</h1>
          <p className="contact-subtitle">Visitanos y conocé nuestra colección en persona</p>
        </div>

        {loading ? (
          <div className="contact-loading">
            <div className="spinner-border" role="status"></div>
          </div>
        ) : locations.length === 0 ? (
          <div className="contact-empty">
            <i className="fas fa-map-marker-alt"></i>
            <p>Próximamente estaremos publicando nuestras ubicaciones</p>
          </div>
        ) : (
          <div className="contact-content">
            <div className="contact-map-section">
              {MY_MAPS_EMBED_URL ? (
                <iframe
                  className="contact-map"
                  src={MY_MAPS_EMBED_URL}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa de locales"
                />
              ) : selected ? (
                // Fallback: mapa gratuito del local seleccionado
                <iframe
                  className="contact-map"
                  src={`https://maps.google.com/maps?q=${selected.lat},${selected.lng}&z=15&output=embed`}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`Mapa de ${selected.name}`}
                />
              ) : (
                <div className="contact-map-placeholder">
                  <i className="fas fa-map"></i>
                  <p>Seleccioná un local para ver el mapa</p>
                </div>
              )}
            </div>

            <div className="contact-cards">
              {locations.map(loc => (
                <div
                  key={loc._id}
                  className={`contact-card ${selected?._id === loc._id ? 'contact-card-active' : ''}`}
                  onClick={() => setSelected(loc)}
                >
                  {loc.image && (
                    <div className="contact-card-image">
                      <img src={getDisplayImageUrl(loc.image)} alt={loc.name} />
                    </div>
                  )}
                  <div className="contact-card-body">
                    <h3 className="contact-card-name">{loc.name}</h3>
                    <div className="contact-card-info">
                      <p>
                        <i className="fas fa-map-marker-alt"></i>
                        {loc.address}{loc.city && `, ${loc.city}`}
                      </p>
                      {loc.phone && (
                        <p>
                          <i className="fas fa-phone"></i>
                          <a href={`tel:${loc.phone}`}>{loc.phone}</a>
                        </p>
                      )}
                      {loc.email && (
                        <p>
                          <i className="fas fa-envelope"></i>
                          <a href={`mailto:${loc.email}`}>{loc.email}</a>
                        </p>
                      )}
                      {loc.hours && (
                        <p>
                          <i className="fas fa-clock"></i>
                          {loc.hours}
                        </p>
                      )}
                    </div>
                    <button
                      className="contact-card-directions"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(`https://www.google.com/maps/dir/?api=1&destination=${loc.lat},${loc.lng}`, '_blank');
                      }}
                    >
                      <i className="fas fa-directions me-2"></i>
                      Cómo llegar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Contact;
